import { useState, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import useStyles from "./styles";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useHistory, withRouter } from "react-router-dom";
import { useAuth } from "oidc-react";
import { UserCreate } from "../../interfaces/UserCreate";
import InputLabel from "@material-ui/core/InputLabel";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const newUser: UserCreate = {
    activo: true,
    nombre: "",
    apellido: "",
    email: "",
    linkWithGoogle: false,
    linkWithMicrosoft: false,
    password: "",
};

const Create = ({ ...props }: any) => {
    const MySwal = withReactContent(Swal)
    const [user, setUser] = useState<UserCreate>(newUser);

    const [error, setError] = useState(false);

    const history = useHistory();
    var auth = useAuth();

    var classes = useStyles();

    const create = async (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        if (user.email !== "" && user.nombre !== "" && user.apellido !== "") {
            const response = await fetch(`/api/user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth?.userData?.access_token,
                },
                body: JSON.stringify(user),
            });
            if (response.status == 401) {
                history.push("/user");
                return;
            }

            const data = await response.json();


            if (data > 0) {
                    await MySwal.fire({
                        title: <strong>Usuario creado!</strong>,
                        html: <i>Se ha creado el usuario de manera satisfactoria!</i>,
                        icon: 'success'
                    })
                
                history.push(`/user/addRole/${data}`);
            }

            setError(false);
        } else {
            setError(true);
        }
    };

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <PersonAddOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Nuevo Usuario
            </Typography>
            <form className={classes.form}>
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    type="email"
                    autoFocus
                    placeholder="Email de usuario"
                    onChange={(e) => {
                        setUser({ ...user, email: e.target.value });
                        setError(false);
                    }}
                    error={error}
                />

                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="name"
                    label="Nombre"
                    name="name"
                    placeholder="Nombre de Usuario"
                    onChange={(e) => {
                        setUser({ ...user, nombre: e.target.value });
                        setError(false);
                    }}
                    error={error}
                />

                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="apellido"
                    label="Apellido"
                    name="apellido"
                    placeholder="Apellido de Usuario"
                    onChange={(e) => {
                        setUser({ ...user, apellido: e.target.value });
                        setError(false);
                    }}
                    error={error}
                />

                {error && (
                    <InputLabel
                        style={{
                            color: "#f44336",
                            marginTop: 20,
                            marginBottom: 20,
                        }}
                    >
                        Todos los campos son requeridos
                    </InputLabel>
                )}
                <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={(e: any) => create(e)}
                >
                    Crear
                </Button>
            </form>
        </Fragment>
    );
};

export default withRouter(Create);
